import { useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Outlet } from 'react-router'

import * as Sentry from '@sentry/react'

import { useAudiences } from 'app/audiences/application'
import { useConnections } from 'app/connections/application'

import { ErrorPage } from '../ErrorPage'
import { Header } from '../Header'
import styles from './Page.module.scss'

const Page = () => {
  const { fetchConnections } = useConnections()
  const { fetchAudiences } = useAudiences()

  useEffect(() => {
    const fetchData = async () => {
      await fetchConnections()
      await fetchAudiences()
    }

    void fetchData()
  }, [fetchAudiences, fetchConnections])

  return (
    <div className={styles.page}>
      <Header />
      <main className={styles.main}>
        <ErrorBoundary
          FallbackComponent={ErrorPage}
          onError={(error) => Sentry.captureException(error)}
        >
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  )
}

export default Page
